
export default function SectionHeader({
  text,
  subtext = null,
  textAlign = "center",
}: {
  text: string;
  subtext?: string | null;
  textAlign?: string;
}) {
  return (
    <div className={`flex flex-col w-full items-center justify-center text-${textAlign}`}>

      {/* Header */}
      <h2 className="w-2/3 sm:w-full text-dark-grey text-xl md:text-2xl lg:text-3xl font-bold">{text}</h2>

      {/* Subheader */}
      {subtext !== null && (
        <p className="w-2/3 sm:w-full text-dark-grey text-sm sm:text-base font-medium max-w-3xl mx-auto">
          {subtext}
        </p>
      )}
    </div>
  );
}
